import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Text, Radio } from 'v3/components';
import './style.css';

export function Filters({ setFilters, filters, selectedDealList, loading, setPage }) {
  if (selectedDealList?.selected_only_closed) {
    const setValues = (value) => {
      if (value?.my_attended) {
        return 3;
      }
      if (value?.attended) {
        return 1;
      }
      if (value?.not_attended) {
        return 2;
      }
      return 0;
    };

    return (
      <Row>
        <Col lg={4} md={4} className="my-1 mt-10">
          <Radio.Group
            onChange={({ target }) => {
              if (target.value === 1) {
                setPage(0);
                setFilters((old) => ({
                  ...old,
                  my_attended: false,
                  attended: true,
                  not_attended: false,
                }));
              } else if (target.value === 2) {
                setPage(0);
                setFilters((old) => ({
                  ...old,
                  my_attended: false,
                  attended: false,
                  not_attended: true,
                }));
              } else if (target.value === 3) {
                setPage(0);
                setFilters((old) => ({
                  ...old,
                  my_attended: true,
                  attended: false,
                  not_attended: false,
                }));
              } else {
                setPage(0);
                setFilters((old) => ({
                  ...old,
                  my_attended: false,
                  attended: false,
                  not_attended: false,
                }));
              }
            }}
            value={setValues(filters)}
            horizontal
          >
            <div className="chat-filters-radio-row">
              <div className="chat-filters-radio-group-main">
                <Radio value={1} disabled={loading}>
                  <Text color="dark" type="label">
                    ATENDIDAS
                  </Text>
                </Radio>
                <div className="chat-filters-radio-item-wide">
                  <Radio value={2} disabled={loading}>
                    <Text color="dark" type="label">
                      NÃO ATENDIDAS
                    </Text>
                  </Radio>
                </div>
                <Radio value={0} disabled={loading}>
                  <Text color="dark" type="label">
                    TODAS
                  </Text>
                </Radio>
              </div>
              <div className="chat-filters-radio-item-wide">
                <Radio value={3} disabled={loading}>
                  <Text color="dark" type="label">
                    MEUS ATENDIMENTOS
                  </Text>
                </Radio>
              </div>
            </div>
          </Radio.Group>
        </Col>
      </Row>
    );
  }
  if (selectedDealList?.selected_in_service) {
    return (
      <Row>
        <Col className="chat-filters-radio-col">
          <div className="chat-filters-radio-group-in-service">
            <Radio.Group
              onChange={({ target }) => {
                if (target.value === 1) {
                  setFilters((old) => ({
                    ...old,
                    my_attended: true,
                  }));
                } else {
                  setFilters((old) => ({
                    ...old,
                    my_attended: false,
                  }));
                }
              }}
              value={filters?.my_attended ? 1 : 0}
              horizontal
            >
              <div className="chat-filters-radio-item-wide">
                <Radio value={1} disabled={loading}>
                  <Text color="dark" type="label">
                    MEUS ATENDIMENTOS
                  </Text>
                </Radio>
              </div>
              <Radio value={0} disabled={loading}>
                <Text color="dark" type="label">
                  TODAS
                </Text>
              </Radio>
            </Radio.Group>
          </div>
        </Col>
      </Row>
    );
  }
  return null;
}
